import { Document, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';


// Styles for mailing labels
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-s',
    padding: "35 10",
  },
  label: {
    width: 189,
    margin: "0 4",
    height: 72,
    // border: "1px solid black"
  },
  labelText: {
    fontSize: 9,
    margin: 4,
  }
});

const MailingLabelsDocument = ({ data }) => {
  return (
    <Document>
      <Page size="letter" style={styles.page}>
        {data.map((label, index) => (
          <View key={index} style={styles.label}>
            <Text style={styles.labelText}>{label.mailingLabelName}</Text>
            <Text style={styles.labelText}>{label.address1}, {label.address2 && `${label.address2},`}</Text>
            <Text style={styles.labelText}>{`${label.city}, ${label.state} ${label.zipCode}`}</Text>
          </View>
        ))}
      </Page>
    </Document>
  );
};

export default MailingLabelsDocument;